import $foreign from "./foreign.cjs";
var drain = $foreign.drain;
var enqueue = $foreign.enqueue;
var $$new = $foreign.new;
export { drain, enqueue, $$new as new };
